import { supabase } from '../../supabaseClient';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

// Story 109 — OBTR 1.0 download (Backgammon Poland rating list). On a 400
// the body's message names every blocking gap — surface it to the director.
export async function downloadObtr(tournamentId: string): Promise<void> {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  if (!token) throw new Error('Not authenticated');
  const res = await fetch(
    `${API_URL}/tournaments/${tournamentId}/obtr/download`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'X-Swiss-Tenant-Host': window.location.hostname,
      },
    },
  );
  if (!res.ok) {
    let message = 'Failed to generate OBTR file';
    try {
      const body = (await res.json()) as { message?: string };
      if (body.message) message = body.message;
    } catch {
      // keep generic message
    }
    throw new Error(message);
  }
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download =
    res.headers.get('content-disposition')?.match(/filename="(.+)"/)?.[1] ??
    'tournament.obtr.json';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
